module.exports = __webpack_public_path__ + "src/app/_content/imgs/mini/discover/MFestival.jpg?69dd5d756f7d811fcdf2dd10f252dcdf";